export enum FILE_SIZE_MEASURE {
    byte = 'byte',
    bytes = 'bytes',
    KB = 'KB',
    MB = 'MB'
}
